/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CancelDiscountResponse {
  applied: boolean;
  percent: number;
  period_end?: string | null;
}
